import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-disclaimer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
  template: `
    <div class="disclaimer">
      <mat-icon class="disclaimer__icon">info_outline</mat-icon>
      <span class="disclaimer__text">{{ message() }}</span>
    </div>
  `,
  styles: [`
    .disclaimer {
      display: flex;
      align-items: center;
      gap: var(--space-sm);
      padding: 10px var(--space-md);
      border-radius: var(--radius-md);
      background: var(--gokuri-background, #f5f5f5);
    }
    .disclaimer__icon {
      font-size: 16px;
      width: 16px;
      height: 16px;
      color: var(--gokuri-text-tertiary);
      flex-shrink: 0;
    }
    .disclaimer__text {
      font-size: var(--font-size-label-sm);
      color: var(--gokuri-text-tertiary);
      line-height: 1.5;
    }
  `],
})
export class DisclaimerComponent {
  readonly message = input.required<string>();
}
